module.exports = __webpack_public_path__ + "static/media/sector-2.13a2dd74.jpg";